(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artesta-promotion-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('artesta-promotion-banner')) {
    customElements.define('artesta-promotion-banner', class extends HTMLElement {
      connectedCallback() {
        const label = this.querySelector('[data-deadline-label]');
        const value = this.querySelector('[data-deadline-value]');
        const expiresAt = Number(this.dataset.expiresAt) * 1000;
        const deadlineAt = Number(this.dataset.deadlineAt || this.dataset.expiresAt) * 1000;
        const previewNow = Number(this.dataset.previewNow) * 1000;
        const previewRealNow = Number(this.dataset.previewRealNow) * 1000;
        const hasPreviewClock = this.dataset.previewNow !== undefined || this.dataset.previewRealNow !== undefined;
        const clockOffset = hasPreviewClock
          ? (Number.isFinite(previewNow) && previewNow > 0 && Number.isFinite(previewRealNow) && previewRealNow > 0
            ? previewNow - previewRealNow : NaN)
          : 0;
        const countdownThreshold = 48 * 60 * 60 * 1000;
        let shortDate;
        if (Number.isFinite(deadlineAt) && deadlineAt > 0) {
          // End is exclusive: midnight Madrid belongs to the following day.
          shortDate = new Intl.DateTimeFormat(this.dataset.locale || 'en', {
            timeZone: 'Europe/Madrid', day: 'numeric', month: 'short',
          }).format(new Date(deadlineAt - 1));
        }
        this.checkExpiry = () => {
          clearTimeout(this.expiryTimer);
          const realNow = Date.now();
          const previewLifetime = expiresAt - realNow;
          const remaining = deadlineAt - (realNow + clockOffset);
          if (!Number.isFinite(remaining) || remaining <= 0 || !Number.isFinite(previewLifetime) || previewLifetime <= 0) {
            this.hidden = true;
            return;
          }
          const countdown = remaining < countdownThreshold;
          this.dataset.deadlineMode = countdown ? 'countdown' : 'date';
          let display = shortDate;
          if (countdown) {
            const seconds = Math.ceil(remaining / 1000);
            display = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
              .map(part => String(part).padStart(2, '0')).join(':');
          }
          if (label && value) {
            const text = countdown ? this.dataset.countdownLabel : this.dataset.dateLabel;
            if (label.textContent !== text) label.textContent = text;
            if (value.textContent !== display) value.textContent = display;
          }
          // Recompute from the deadline, so suspended tabs never accumulate drift.
          const nextTick = countdown ? remaining % 1000 || 1000 : remaining - countdownThreshold + 1;
          this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, previewLifetime, nextTick, 60000));
        };
        this.checkExpiry();
        document.addEventListener('visibilitychange', this.checkExpiry);
        window.addEventListener('pageshow', this.checkExpiry);
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.checkExpiry);
        window.removeEventListener('pageshow', this.checkExpiry);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
